import { saveLessonNote, getLessonNote } from "@saas/service-api/src/course";
import { getLessonOutline } from "@saas/service-api/src/learning-center";
import { Message } from "element-ui";
const state = {
  initNoteContent: "", // 笔记内容
  noteContent: "", // 当前笔记内容
  noteDetail: {}, // 笔记详情

  subTitle: "", // 视频字幕jsonUrl
  subtitleSwitch: 2, // 字幕开关 1=开 2=关
  outLineList: [], // 切片列表
  canOpenAIModel: false, // 可开启ai看课
  getOutLineStatus: "loading", //切片列表获取状态
  urlProgressTime: null, //页面路径参数:播放位置
};

const mutations = {
  setNoteContent: (state, content) => {
    state.noteContent = content;
  },
  setInitNoteContent: (state, content) => {
    state.initNoteContent = state.noteContent;
  },
  setNoteDetail: (state, content) => {
    state.noteDetail = content;
  },
  setSubTitle: (state, content) => {
    state.subTitle = content;
  },
  setSubtitleSwitch: (state, content) => {
    state.subtitleSwitch = content;
  },
  setOutLineList: (state, content) => {
    state.outLineList = content;
  },
  setCanOpenAIModel: (state, content) => {
    state.canOpenAIModel = content;
  },
  setGetOutLineStatus: (state, content) => {
    state.getOutLineStatus = content;
  },
  setUrlProgressTime: (state, content) => {
    state.urlProgressTime = content;
  },
};

const actions = {
  //获取课时笔记
  apiGetNoteInfo({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      getLessonNote(params)
        .then(({ code, data, message }) => {
          if (code === 1) {
            const detail = data || {};
            commit("setNoteDetail", detail);
            commit("setNoteContent", detail.content || "");
            commit("setInitNoteContent");
            resolve({ code, data, message });
          } else {
            Message({
              message,
              type: "error",
              duration: 3 * 1000,
            });
            resolve({ code, message });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取切片列表
  apiGetLessonOutline({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      commit("setGetOutLineStatus", "loading");
      getLessonOutline(params)
        .then(({ code, data, message }) => {
          if (code === 1) {
            commit("setOutLineList", data?.outline || []);
            const rawSubtitle = data?.subtitle || "";
            const subtitleUrl = rawSubtitle && !rawSubtitle.startsWith("http")
              ? `${process.env.VUE_APP_CDN_URL}/${rawSubtitle.replace(/^\//, '')}`
              : rawSubtitle;
            commit("setSubTitle", subtitleUrl);
            commit("setGetOutLineStatus", "success");
          } else {
            Message({
              message,
              type: "error",
            });
            commit("setGetOutLineStatus", "error");
          }
          if (data === null) {
            commit("setCanOpenAIModel", false);
          } else {
            commit("setCanOpenAIModel", true);
          }
          resolve({ code, data, message });
        })
        .catch((error) => {
          commit("setGetOutLineStatus", "error");
          commit("setOutLineList", []);
          commit("setCanOpenAIModel", false);
          reject(error);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
